import './App.css';
import AnimatedBackground from './components/AnimatedBackground';
import HomePage from './homePage/homePage';
import ResumeScroller from './resume/resumeScroller';
import SiteHeader from './components/SiteHeader';
import PokePage from './pokePage/landingPage';
import CasinoPage from './casinoPage/landingPage';
import CraybotPage from './craybotPage/CraybotPage';
import { useEffect, useState } from 'react';

function getCurrentPath() {
  const path = window.location.pathname || '/';

  if (path === '/craybot' || path === '/craybot/') {
    return '/craybot';
  }

  if (path === '/poke') {
    return '/poke';
  }

  if (path === '/casino') {
    return '/casino';
  }

  if (path === '/resume') {
    return '/resume';
  }

  return '/';
}

function App() {
  const [currentPath, setCurrentPath] = useState(getCurrentPath);
  const needsBackground = currentPath === '/resume';

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const handlePopState = () => {
      setCurrentPath(getCurrentPath());
      window.scrollTo(0, 0);
    };

    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const navigate = (path) => {
    if (path === currentPath) {
      return;
    }

    window.history.pushState({}, '', path);
    setCurrentPath(path);
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  };

  return (
    <>
      {needsBackground ? <AnimatedBackground /> : null}
      <SiteHeader currentPath={currentPath} onNavigate={navigate} />
      {currentPath === '/poke' ? (
        <PokePage />
      ) : currentPath === '/casino' ? (
        <CasinoPage />
      ) : currentPath === '/craybot' ? (
        <CraybotPage />
      ) : currentPath === '/resume' ? (
        <ResumeScroller />
      ) : (
        <HomePage />
      )}
    </>
  );
}

export default App;
